// Auth types
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const SET_USER_ACTIVE_DECK = 'SET_USER_ACTIVE_DECK';
export const SET_USER_ACTIVE_TEAM = 'SET_USER_ACTIVE_TEAM';

// Game Preference types
export const SET_GAME_PREFERENCES = 'SET_GAME_PREFERENCES';
export const UPDATE_GAME_PREFERENCE = 'UPDATE_GAME_PREFERENCE';
export const LOAD_PREFERENCES_FROM_USER = 'LOAD_PREFERENCES_FROM_USER';

// Theme types
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const SET_THEME = 'SET_THEME';
export const SET_DARK_MODE = 'SET_DARK_MODE';


// Match types (VGC)
export const GET_MATCHES = 'GET_MATCHES';
export const ADD_MATCH = 'ADD_MATCH';
export const DELETE_MATCH = 'DELETE_MATCH';
export const MATCH_ERROR = 'MATCH_ERROR';
export const CLEAR_MATCHES = 'CLEAR_MATCHES';
export const SET_LOADING = 'SET_LOADING';

// TCG Match types (NEW)
export const GET_TCG_MATCHES = 'GET_TCG_MATCHES';
export const GET_TCG_MATCH = 'GET_TCG_MATCH';
export const ADD_TCG_MATCH = 'ADD_TCG_MATCH';
export const UPDATE_TCG_MATCH = 'UPDATE_TCG_MATCH';
export const DELETE_TCG_MATCH = 'DELETE_TCG_MATCH';
export const CLEAR_TCG_MATCH = 'CLEAR_TCG_MATCH';
export const CLEAR_TCG_MATCHES = 'CLEAR_TCG_MATCHES';
export const TCG_MATCH_ERROR = 'TCG_MATCH_ERROR';
export const SET_TCG_LOADING = 'SET_TCG_LOADING';
export const CLEAR_TCG_ERRORS = 'CLEAR_TCG_ERRORS';

// VGC Match types
export const GET_VGC_MATCHES = 'GET_VGC_MATCHES';
export const GET_VGC_MATCH = 'GET_VGC_MATCH';
export const ADD_VGC_MATCH = 'ADD_VGC_MATCH';
export const UPDATE_VGC_MATCH = 'UPDATE_VGC_MATCH';
export const DELETE_VGC_MATCH = 'DELETE_VGC_MATCH';
export const CLEAR_VGC_MATCH = 'CLEAR_VGC_MATCH';
export const CLEAR_VGC_MATCHES = 'CLEAR_VGC_MATCHES';
export const VGC_MATCH_ERROR = 'VGC_MATCH_ERROR';
export const SET_VGC_LOADING = 'SET_VGC_LOADING';
export const CLEAR_VGC_ERRORS = 'CLEAR_VGC_ERRORS';

// Deck Types
export const GET_DECKS = 'GET_DECKS';
export const GET_DECK = 'GET_DECK';
export const ADD_DECK = 'ADD_DECK';
export const UPDATE_DECK = 'UPDATE_DECK';
export const DELETE_DECK = 'DELETE_DECK';
export const DECK_ERROR = 'DECK_ERROR';
export const CLEAR_DECKS = 'CLEAR_DECKS';
export const CLEAR_CURRENT_DECK = 'CLEAR_CURRENT_DECK';
export const SET_CURRENT_DECK = 'SET_CURRENT_DECK';
export const SET_ACTIVE_DECK = 'SET_ACTIVE_DECK';
export const CLEAR_ACTIVE_DECK = 'CLEAR_ACTIVE_DECK';

// Team context types
export const GET_TEAMS = 'GET_TEAMS';
export const GET_TEAM = 'GET_TEAM';
export const ADD_TEAM = 'ADD_TEAM';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';
export const TEAM_ERROR = 'TEAM_ERROR';
export const CLEAR_TEAMS = 'CLEAR_TEAMS';
export const SET_CURRENT_TEAM = 'SET_CURRENT_TEAM';
export const CLEAR_CURRENT_TEAM = 'CLEAR_CURRENT_TEAM';
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
export const CLEAR_ACTIVE_TEAM = 'CLEAR_ACTIVE_TEAM';

// Card Types
export const SEARCH_CARDS = 'SEARCH_CARDS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CARD_ERROR = 'CARD_ERROR';
export const ADD_CARD_TO_DECK = 'ADD_CARD_TO_DECK';
export const REMOVE_CARD_FROM_DECK = 'REMOVE_CARD_FROM_DECK';

// Match Group Types
export const GET_MATCH_GROUPS = 'GET_MATCH_GROUPS';
export const GET_MATCH_GROUP = 'GET_MATCH_GROUP';
export const ADD_MATCH_GROUP = 'ADD_MATCH_GROUP';
export const UPDATE_MATCH_GROUP = 'UPDATE_MATCH_GROUP';
export const DELETE_MATCH_GROUP = 'DELETE_MATCH_GROUP';
export const ADD_MATCHES_TO_GROUP = 'ADD_MATCHES_TO_GROUP';
export const REMOVE_MATCHES_FROM_GROUP = 'REMOVE_MATCHES_FROM_GROUP';
export const MATCH_GROUP_ERROR = 'MATCH_GROUP_ERROR';
export const CLEAR_MATCH_GROUPS = 'CLEAR_MATCH_GROUPS';

// Friend Types
export const GET_FRIENDS = 'GET_FRIENDS';
export const GET_FRIEND_REQUESTS = 'GET_FRIEND_REQUESTS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const SEND_FRIEND_REQUEST = 'SEND_FRIEND_REQUEST';
export const ACCEPT_FRIEND_REQUEST = 'ACCEPT_FRIEND_REQUEST';
export const REJECT_FRIEND_REQUEST = 'REJECT_FRIEND_REQUEST';
export const REMOVE_FRIEND = 'REMOVE_FRIEND';
export const FRIEND_ERROR = 'FRIEND_ERROR';
export const CLEAR_FRIENDS = 'CLEAR_FRIENDS';

// Notification Types
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

// Feedback Types
export const GET_FEEDBACK = 'GET_FEEDBACK';
export const GET_USER_FEEDBACK = 'GET_USER_FEEDBACK';
export const ADD_FEEDBACK = 'ADD_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK';
export const ARCHIVE_FEEDBACK = 'ARCHIVE_FEEDBACK';
export const FEEDBACK_ERROR = 'FEEDBACK_ERROR';
export const CLEAR_FEEDBACK = 'CLEAR_FEEDBACK';

// TCG Opponent Decks Types
export const GET_OPPONENT_DECKS = 'GET_OPPONENT_DECKS';
export const ADD_OPPONENT_DECK = 'ADD_OPPONENT_DECK';
export const UPDATE_OPPONENT_DECK = 'UPDATE_OPPONENT_DECK';
export const DELETE_OPPONENT_DECK = 'DELETE_OPPONENT_DECK';
export const OPPONENT_DECK_ERROR = 'OPPONENT_DECK_ERROR';
export const CLEAR_OPPONENT_DECKS = 'CLEAR_OPPONENT_DECKS';
export const SET_OPPONENT_DECK_LOADING = 'SET_OPPONENT_DECK_LOADING';

// Season Types
export const GET_SEASONS = 'GET_SEASONS';
export const GET_CURRENT_SEASON = 'GET_CURRENT_SEASON';
export const CREATE_SEASON = 'CREATE_SEASON';
export const UPDATE_SEASON = 'UPDATE_SEASON';
export const DELETE_SEASON = 'DELETE_SEASON';
export const SET_CURRENT_SEASON = 'SET_CURRENT_SEASON';
export const GET_SEASON_STATS = 'GET_SEASON_STATS';
export const SEASON_ERROR = 'SEASON_ERROR';
export const CLEAR_SEASON_ERROR = 'CLEAR_SEASON_ERROR';